export enum DiscontinuedArticleStatusType {
    REPLACED = "REPLACED",
    NEW = "NEW",
    NOT_REPLACED = "NOT_REPLACED",
    IGNORED = "IGNORED",
}